import {each} from '../lang/array';
import {keys as objectKeys, owns} from '../lang/object';
import {Source} from '../streams';

const
    timestamp = delta => (
        delta ?
            (Date.now() + (delta * 1000)) :
            null),

    createStorage = (name, storage) => {
        let timeouts = {};
        const
            cleared = new Source(),
            cancel = key => {
                if (owns(timeouts, key) && timeouts[key]) {
                    clearTimeout(timeouts[key]);
                    timeouts[key] = null;
                }
            },
            expire = (key, expiration) => {
                cancel(key);
                if (expiration) {
                    timeouts[key] = (
                        setTimeout(
                            () => {
                                timeouts[key] = null;
                                clear(key);
                            },
                            expiration - Date.now()));
                }
            },
            read = (key, fn) => {
                let data = null;

                try {
                    data = (
                        JSON.parse(
                            storage.getItem(key)));
                } catch (error) {}
                if (data && owns(data, 'values') && owns(data, 'expiration')) {
                    return fn(data);
                }
            },
            keys = () => {
                const keys = [];

                for (let i = 0, length = storage.length; i < length; i += 1) {
                    keys.push(storage.key(i));
                }
                return keys;
            },
            get = key => (
                read(
                    key,
                    ({values, expiration}) => {
                        if (expiration) {
                            if (expiration > Date.now()) {
                                return values;
                            } else {
                                clear(key);
                            }
                        } else {
                            return values;
                        }
                    })),
            set = (key, values, expiration) => {
                expiration = timestamp(expiration);
                storage.setItem(
                    key,
                    JSON.stringify({
                        values,
                        expiration
                    }));
                expire(key, expiration);
                return values;
            },
            update = (key, values, expiration) => (
                set(
                    key,
                    {
                        ...get(key) || {},
                        ...values
                    },
                    expiration)),
            clear = key => {
                cancel(key);
                storage.removeItem(key);
                cleared.next(key);
            },
            initialize = () => {
                each(keys(), key => {
                    read(
                        key,
                        ({expiration}) => {
                            if (expiration) {
                                if (expiration > Date.now()) {
                                    expire(key, expiration);
                                } else {
                                    clear(key);
                                }
                            }
                        });
                });
            },
            refresh = () => {
                each(objectKeys(timeouts), key => {
                    cancel(key);
                });
                timeouts = {};
                initialize();
            };

        initialize();
        if (typeof document.hidden !== 'undefined') {
            document.addEventListener(
                'visibilitychange',
                () => {
                    if (!document.hidden) {
                        refresh();
                    }
                });
        } else {
            document.addEventListener('focus', refresh);
        }
        return {
            name,
            keys,
            get,
            set,
            update,
            clear,
            cleared
        };
    };

export {
    createStorage
};
